import { render, staticRenderFns } from "./GroupOfAccreditationMenu.vue?vue&type=template&id=6918a7ea"
import script from "./GroupOfAccreditationMenu.vue?vue&type=script&lang=js"
export * from "./GroupOfAccreditationMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports